import { SlotGameType1_3 } from "../SlotGameType1_3"
export class GenericGame3 extends SlotGameType1_3
{
}